<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <listino
          v-if="isMounted"
          @refresh="refresh"
          :idListino="idListino"
          :listino="listino"
        />
      </div>
      <div class="col-md-12">
        <b-tabs type="is-toggle" expanded>
          <!-- AREA GEOGRAFICA -->
          <b-tab-item label="Aree Geografiche" icon="web">
            <div class="row insert">
              <div class="col-md-9 col-9">
                <input
                  type="text"
                  placeholder="Inserire una nuova area..."
                  @keyup.enter="addGeo"
                  v-model="newAddress"
                />
              </div>

              <div class="col-md-3 col-3">
                <i
                  class="fas fa-plus blue"
                  @click="addGeo"
                  title="Aggiungi area"
                ></i>
              </div>
            </div>
            <div v-for="(g, key) in geo">
              <aree_geo :key="key" :geo="g" @refresh="refresh" />
            </div>
          </b-tab-item>
          <!-- SCAGLIONI -->
          <b-tab-item label="Scaglioni di Prezzo" icon="currency-usd">
            <div class="container-fluid xs-flex ranks-active">
              <div class="row scaglioni legenda">
                <div class="col-md-2">V/P min</div>
                <div class="col-md-2">V/P max</div>
                <div class="col-md-2">Standard</div>
                <div class="col-md-2">Express</div>
              </div>
              <div class="row scaglioni new-ranks">
                <input class="col-md-2" type="number" v-model="ranks.min" />
                <input class="col-md-2" type="number" v-model="ranks.max" />
                <input class="col-md-2" type="number" v-model="ranks.stPrice" />
                <input
                  class="col-md-2"
                  @keyup.enter="addRank()"
                  type="number"
                  v-model="ranks.exPrice"
                />
                <i
                  class="fas fa-plus blue col-md-2"
                  @click="addRank()"
                  title="Aggiungi Rank"
                ></i>
              </div>
            </div>
            <i
              class="fas fa-plus out blue col-md-12"
              @click="addRank()"
              title="Aggiungi Rank"
            ></i>

            <div class="container-fluid mb-5" v-for="(s, key) in scaglioni">
              <scaglioni :key="key" :scaglioni="s" @refresh="refreshRanks" />
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
      <img
        class="close"
        @click="close"
        :src="url('/media/icons/svg/close.svg')"
        alt="close"
      />
    </div>
  </div>
</template>

<script>
import listino from "./edit/index";
import aree_geo from "./edit/aree-geo";
import scaglioni from "./edit/scaglioni";

export default {
  name: "edit-listino",
  components: { listino, aree_geo, scaglioni },
  props: ["idListino"],
  data() {
    return {
      listino: null,
      geo: null,
      scaglioni: null,
      isMounted: false,
      newAddress: null,
      ranks: [
        {
          min: 0.0,
          max: 0.0,
          stPrice: 0.0,
          exPrice: 0.0,
        },
      ],
    };
  },
  mounted() {
    this.getListinoData();
  },
  methods: {
    addRank: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "create-rank",
          id_listino: this.idListino,
          min: parseFloat(this.ranks.min),
          max: parseFloat(this.ranks.max),
          standard: parseFloat(this.ranks.stPrice),
          express: parseFloat(this.ranks.exPrice),
        },
      }).then((res) => {
        //console.log(res.data);
        this.ranks = [
          {
            min: 0.0,
            max: 0.0,
            stPrice: 0.0,
            exPrice: 0.0,
          },
        ];
        this.$emit("refreshed", true);
      });
    },

    addGeo: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "create-geoarea",
          id_listino: this.idListino,
          address: this.newAddress,
        },
      })
        .then((res) => {
          //console.log(res);
          this.$emit("refreshed", true);
        })
        .catch((err) => {
          console.log(err.response.data.message);
        });
    },
    refresh: function () {
      this.$emit("refreshed", true);
    },
    refreshRanks: function () {
      this.$emit("refreshed", true);
    // $( ".ranks-active" ).offsetParent().addClass('is-active');
    },

    getListinoData: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "singleListino",
          id: this.idListino,
        },
      }).then((res) => {
        //console.log(res.data)
        this.listino = {
          nome: res.data.listino.nome,
          descrizione: res.data.listino.descrizione,
        };

        this.geo = res.data.listino.geoarea;
        this.scaglioni = res.data.listino.shippingpricerank;
        this.isMounted = true;
      });
    },
    close: function () {
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .row {
    background-color: white;
    padding: 50px 0; //    padding: 50px;

    position: relative;

    &.insert {
      padding: 0;
      margin: 10px 0;

      input {
        width: 100%;
      }

      svg {
        cursor: pointer;

        path {
          fill: green;
        }
      }
    }

    &.scaglioni {
      padding: 0;
      margin-bottom: 20px;
    }
    .new-ranks {
      input {
        margin-right: 5px;
      }
    }

    .close {
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 4%;
      filter: brightness(0);
    }
  }
}
.xs-flex {
  display: flex;
  .scaglioni {
    width: 50%;
    flex-direction: column;
  }
  .fa-plus {
    display: none;
  }
}
.out {
  display: block;
  text-align: center;
}

@media (min-width: 768px) {
  .xs-flex {
    display: block;
    .scaglioni {
      width: 100%;
      flex-direction: row;
    }
    .fa-plus {
      display: block;
    }
  }
  .out {
    display: none;
  }
}
</style>
